<template>
  <v-container fluid class="mx-0 px-0">
    <div class="d-flex">
      <template v-if="isNegaliojantis">
        <el-autocomplete
          class="mt-3"
          :readonly="skubaReadonly"
          :items="skubos"
          itemvalue="value"
          itemtext="text"
          label="Vertinimo skuba"
          :validate-key="`skuba`"
          tooltip="Modal NTR tikslinimas. Skuba"
          v-model="skubaSelect"
        />
      </template>
      <template v-if="!isNegaliojantis">
        <el-text-field
          readonly
          class="mt-3"
          label="Vertinimo skuba"
          tooltip="Modal NTR tikslinimas. Skuba"
          value="-"
        />
      </template>
      <el-button
        v-if="canSkubaChangeAll"
        class="ml-5 mt-5"
        primary
        @click.native.stop="skubaChangeAll()"
      >
        Taikyti visiems registrams
      </el-button>
    </div>
    <v-data-table
      :class="tableClass"
      :headers="filteredHeaders"
      :items="itemsList"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #[`item.vertinimas_galiojantis`]="{ item }">
        <el-busena :busena="item.vertinimas_galiojantis" taip-ne />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import math from '../../mixins/math'
export default {
  name: 'ModalNtrTikslinimasTurtas',
  props: {
    turtai: Array,
    skubos: Array,
    skuba: Number,
    canCheck: Boolean,
    canSkubaChangeAll: Boolean,
  },
  mixins: [math],
  data() {
    return {
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Unikalus numeris',
          align: 'start',
          value: 'tur_identifikatorius',
        },
        {
          text: 'Vertinimo data',
          align: 'start',
          value: 'vertinimo_data',
        },
        {
          text: 'Vertinimas galiojantis',
          align: 'start',
          value: 'vertinimas_galiojantis',
        },
        {
          text: 'Kaina, Eur',
          align: 'start',
          value: 'kainaFormat',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.turtai.map(item => {
        item.vertinimas_galiojantis = !!item.vertinimas_galiojantis
        item.kainaFormat = !item.vertinimas_galiojantis
          ? this.moneyformat(item.kainos[this.skuba])
          : '-'
        return item
      })
    },
    isNegaliojantis() {
      return (
        this.itemsList.filter(item => !item.vertinimas_galiojantis).length > 0
      )
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    tableClass() {
      return 'miniTable'
    },
    skubaSelect: {
      get() {
        return this.skuba
      },
      set(value) {
        this.skubaChange(value)
      },
    },
    skubaReadonly() {
      return !this.canCheck
    },
  },
  methods: {
    skubaChange(value) {
      this.$emit('skubaChange', value)
    },
    skubaChangeAll() {
      this.$emit('skubaChangeAll', this.skubaSelect)
    },
  },
}
</script>
